import { ProductGender } from '@onrunning/backstage-models';
import { ProductAvailabilityInfo } from './product-availability-info';
import { ProductMainGroups } from './product-main-group.enum';

export class MatrixProduct {
  /**
   * Product barcode / ean number
   * @example 7630040571159
   */
  public productId: string;

  /**
   * Available quantity
   * @example 127
   */
  public availableQuantity: number;

  /**
   * Color name
   * @example All Black
   */
  public color: string;

  /**
   * Launch date of the item, from this date an item nots b available to buy anymore
   * @example 2022-12-31T00:00:00.000Z
   */
  public dropOutDate: string;

  /**
   * Id for the fabric (color)
   * @example 99674
   */
  public fabricId: string;

  /**
   * Item gender
   * @example 0
   */
  public gender: ProductGender;

  /**
   * Launch date of the item, from this date an item is available to buy
   * @example 2022-08-20T00:00:00.000Z
   */
  public launchDate: string;

  /**
   * Product main group / category
   * @example shoes
   */
  public mainGroup: ProductMainGroups;

  /**
   * Available quantity
   * @example 127
   */
  public minQuantity: number;

  /**
   * Available quantity
   * @example 127
   */
  public quantity: number;

  /**
   * Image url
   * @example "https://onretailimages.blob.core.windows.net/prod-mediaserver/Products/28.99674_000_001.png"
   */
  public picUrl: string;

  /**
   * product group name
    @example Cloud Hi Waterproof 1
  */
  public productGroupId: string;

  /**
   * product group name
    @example Cloud Hi Waterproof 1
  */
  public productGroupName: string;

  /**
   * item number
    @example 28.99674
  */
  public productGroupNumber: string;

  /**
   * US size value
    @example 10.5
  */
  public sizeId: string;

  /**
   * Size group name, generrally, but not always, contains a category / main category + a gender
    @example Shoes-M
  */
  public sizeGroup: string;

  /**
   * name of the product without the size
    @example Cloud Hi Waterproof 1 M All Black
  */
  public productName: string;

  /**
   * Date were an item would be available if not available at the moment (availableQuantity = 0)
   * @example 2022-10-01T00:00:00.000Z
   */
  public availabilityDate?: string;

  /**
   * original total ordered before edition
    @example 10
  */
  public originalQuantity = 0;

  /**
   * total ordered
    @example 10
  */
  public total = 0;

  /**
   * product availability information
    @example { availabilityText: 'not-available', availabilityColorClass: 'red'}
  */
  public availabilityInfo?: ProductAvailabilityInfo;

  /**
    @deprecated
  */
  public description: string;

  /**
    @deprecated
  */
  public itemNumber: string;

  /**
    @deprecated
  */
  public groupName: string;

  /**
    @deprecated
  */
  public fabricName: string;

  /**
    @deprecated
  */
  public genderSizeName: string;
}
